module.exports = __webpack_public_path__ + "assets/img/tit.148de70b.png";